export default __webpack_public_path__ + "static/floral-3-5cb4a60017637fddfe5683a45a7bdabe.webp";